<template>
    <section id="vue-attire">
        <h3>Attire</h3>
        <p>Please dress in semi-formal cocktail attire.</p>
    </section>
</template>

<script>
export default {
    name: 'attire-view',
    data: () => ({})
};
</script>



// WEBPACK FOOTER //
// src/views/attire.vue?e2731c3e